import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { Star } from "lucide-react";

const testimonials = [
  {
    name: "Mike Rodriguez",
    role: "Rodriguez 24/7 Plumbing",
    quote: "We were missing many calls especially during abnormal times such as 12 am or so, but after this system, we don't really have to worry about taking those calls anymore, though we still have the show up and do the job",
    initials: "MR",
    stars: 5,
  },
  {
    name: "Jake Thompson",
    role: "Thompson & Sons Plumbing",
    quote: "Noah was a nice guy to work with, his team managed my system well, it recovers all missed call which is great.",
    initials: "JT",
    stars: 5,
  },
  {
    name: "Carlos Mendez",
    role: "Mendez Drain Solutions",
    quote: "Integrating Ai into my business sounded skeptical at first, but Noah helped me through out the whole process and it was great.",
    initials: "CM",
    stars: 5,
  },
  {
    name: "Brian Walsh",
    role: "Walsh Emergency Plumbing",
    quote: "I finally hit 10 jobs this month thanks to Velocity Lab's system. It looks really confusing but Noah explained everything so clearly and guided me throughout every step. Awesome!",
    initials: "BW",
    stars: 5,
  },
];

export default function TestimonialsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-24 md:py-32 px-6 md:px-12"
      style={{ backgroundColor: "#0A0A0A" }}
    >
      <div className="max-w-7xl mx-auto" ref={ref}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <span
            className="inline-flex items-center gap-2 text-sm uppercase tracking-widest text-[#5B8DEF] font-medium mb-4"
            style={{ fontFamily: "Manrope, sans-serif" }}
            data-testid="testimonials-label"
          >
            <span className="w-6 h-px bg-[#5B8DEF]"></span>
            Testimonials
            <span className="w-6 h-px bg-[#5B8DEF]"></span>
          </span>
          <h2
            className="text-3xl md:text-4xl tracking-tight font-semibold text-white"
            style={{ fontFamily: "Outfit, sans-serif" }}
            data-testid="testimonials-headline"
          >
            Plumbers Love Us.
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-5">
          {testimonials.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.1 * (i + 1) }}
              data-testid={`testimonial-${i}`}
              className="bg-[#121212] border border-white/[0.06] rounded-lg p-7 hover:border-white/[0.12] transition-all duration-300"
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.stars }).map((_, si) => (
                  <Star key={si} className="w-3.5 h-3.5 text-amber-400 fill-amber-400" />
                ))}
              </div>

              <p
                className="text-[#A3A3A3] text-sm leading-relaxed mb-6"
                style={{ fontFamily: "Manrope, sans-serif" }}
              >
                "{t.quote}"
              </p>

              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-[#1A1A1A] border border-white/[0.08] flex items-center justify-center flex-shrink-0">
                  <span
                    className="text-xs font-semibold text-[#A3A3A3]"
                    style={{ fontFamily: "Outfit, sans-serif" }}
                  >
                    {t.initials}
                  </span>
                </div>
                <div>
                  <p
                    className="text-sm font-semibold text-white"
                    style={{ fontFamily: "Outfit, sans-serif" }}
                  >
                    {t.name}
                  </p>
                  <p
                    className="text-xs text-[#A3A3A3]"
                    style={{ fontFamily: "Manrope, sans-serif" }}
                  >
                    {t.role}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
